import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'filter.availabilities.title',
    defaultMessage: 'Disponibilités',
  },
  morning: {
    id: 'filter.availabilities.morning',
    defaultMessage: 'Matin',
  },
  afternoon: {
    id: 'filter.availabilities.afternoon',
    defaultMessage: 'Entre 12h et 17h',
  },
  evening: {
    id: 'filter.availabilities.evening',
    defaultMessage: 'Soir après 17h',
  },
});
